import { Link } from "react-router-dom";
import { 
  FaFacebookF, 
  FaInstagram, 
  FaTelegramPlane, 
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";
import { useTranslation } from "../../hooks/useTranslation";
import logo from "../../assets/logo.png";

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-red-900 text-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M20 20c0-.6-.4-1-1-1s-1 .4-1 1 .4 1 1 1 1-.4 1-1z'/%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-8">
              <Link to="/" className="flex items-center group mb-4">
                <img 
                  src={logo}
                  alt="Bruce Tank Logo" 
                  className="h-40 w-auto transition-transform duration-200 group-hover:scale-105"
                />
                <div className="ml-3">
                  <h2 className="text-xl font-bold text-white">Bruce Uzbekistan</h2>
                  <p className="text-red-200 text-sm">Professional Solutions</p>
                </div>
              </Link>
              <p className="text-red-100 leading-relaxed max-w-lg">
                {t('footer.description') || 'Yuqori sifatli va ishonchli mahsulotlar bilan B2B va B2C mijozlarimizga professional xizmat ko\'rsatamiz.'}
              </p>
            </div>
            
            {/* Contact Info */}
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="bg-white/20 p-2 rounded-lg">
                  <FaPhone className="text-white text-sm" />
                </div>
                <div>
                  <div className="font-semibold text-white">+998 98 100 10 10</div>
                  <div className="text-sm text-red-200 mb-2">Call Center</div>
                  <div className="space-y-1">
                    <div className="text-red-100">+998 88 907 10 10</div>
                    <div className="text-red-100">+998 88 715 10 10</div>
                    <div className="text-sm text-red-200">Service Center</div>
                  </div>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <div className="bg-white/20 p-2 rounded-lg">
                  <FaEnvelope className="text-white text-sm" />
                </div>
                <span className="text-red-100">bruceuzbekistan1@gmail.com</span>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="bg-white/20 p-2 rounded-lg">
                  <FaMapMarkerAlt className="text-white text-sm" />
                </div>
                <span className="text-red-100">Navbahor koʻchasi 66 uy, Kokand, Fergana, Uzbekistan</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">
              {t('footer.quickLinks') || 'Tezkor Havolalar'}
            </h3>
            <ul className="space-y-3">
              {[
                { path: '/', text: t('footer.home') || 'Bosh sahifa' },
                { path: '/about', text: t('footer.about') || 'Biz haqimizda' },
                { path: '/products', text: t('footer.products') || 'Mahsulotlar' },
                { path: '/news', text: t('footer.news') || 'Yangiliklar' },
                { path: '/contact', text: t('footer.contact') || 'Aloqa' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="text-red-100 hover:text-white transition-colors duration-200 flex items-center group"
                  >
                    <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 group-hover:bg-red-200 transition-colors duration-200"></div>
                    {link.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media & Additional Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-white">
              Ijtimoiy Tarmoqlar
            </h3>
            <div className="grid grid-cols-2 gap-3 mb-8">
              <a 
                href="https://www.facebook.com/share/1GNyHXXKsS/?mibextid=LQQJ4d" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 bg-red-800 hover:bg-blue-600 p-3 rounded-lg transition-all duration-200 hover:scale-105"
                aria-label="Facebook"
              >
                <FaFacebookF size={16} />
                <span className="text-sm">Facebook</span>
              </a>
              <a 
                href="https://www.instagram.com/bruce_uzbekistan_?igsh=eTJkdHhtYW42NHFp&utm_source=qr" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 bg-red-800 hover:bg-pink-600 p-3 rounded-lg transition-all duration-200 hover:scale-105"
                aria-label="Instagram"
              >
                <FaInstagram size={16} />
                <span className="text-sm">Instagram</span>
              </a>
              <a 
                href="https://t.me/Bruce_service_uzbekistan" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 bg-red-800 hover:bg-blue-500 p-3 rounded-lg transition-all duration-200 hover:scale-105"
                aria-label="Telegram Service"
                title="Bruce Service"
              >
                <FaTelegramPlane size={16} />
                <span className="text-sm">Service</span>
              </a>
              <a 
                href="https://t.me/tikbazaroptom" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center space-x-2 bg-red-800 hover:bg-blue-400 p-3 rounded-lg transition-all duration-200 hover:scale-105"
                aria-label="Telegram Channel"
                title="Telegram Kanal"
              >
                <FaTelegramPlane size={16} />
                <span className="text-sm">Kanal</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative border-t border-red-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col lg:flex-row items-center justify-between space-y-4 lg:space-y-0">
            <div className="text-red-200 text-sm text-center lg:text-left">
              © {new Date().getFullYear()} BRUCE UZBEKISTAN. {t('footer.copyright') || 'Barcha huquqlar himoyalangan.'}
            </div>
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-6">
              <a 
                href="#" 
                className="text-red-200 hover:text-white text-sm transition-colors duration-200"
              >
                {t('footer.privacyPolicy') || 'Maxfiylik siyosati'}
              </a>
              <a 
                href="#" 
                className="text-red-200 hover:text-white text-sm transition-colors duration-200"
              >
                {t('footer.termsOfUse') || 'Foydalanish shartlari'}
              </a>
              <div className="text-red-200 text-sm">
                {t('footer.developer') || 'Ishlab chiquvchi:'} 
                <a 
                  href="https://aimaa.uz" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-red-100 hover:text-white ml-1 transition-colors duration-200 font-medium"
                >
                  aimaa.uz
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
